import {FAILURE, PENDING, SUCCESS} from '../../constants'

const ACTION = 'GET_AUDIT'

export const GA_FAILURE = `${ACTION}_${FAILURE}`
export const GA_PENDING = `${ACTION}_${PENDING}`
export const GA_SUCCESS = `${ACTION}_${SUCCESS}`

const ITEM_ACTION = 'GET_NEXT_AUDIT_ITEMS'

export const GNI_FAILURE = `${ITEM_ACTION}_${FAILURE}`
export const GNI_PENDING = `${ITEM_ACTION}_${PENDING}`
export const GNI_SUCCESS = `${ITEM_ACTION}_${SUCCESS}`

const ITEM_DELETE_ACTION = 'DELETE_AUDIT_ITEMS'

export const DI_FAILURE = `${ITEM_DELETE_ACTION}_${FAILURE}`
export const DI_PENDING = `${ITEM_DELETE_ACTION}_${PENDING}`
export const DI_SUCCESS = `${ITEM_DELETE_ACTION}_${SUCCESS}`
